<script>
    import RadioWithInput from "./RadioWithInput.svelte";
    import RadioNoInput from "./RadioNoInput.svelte";
    import RadioWithDaysInput from "./RadioWithDaysInput.svelte";

    export let data, filter, change;
</script>
<RadioWithDaysInput change={change} data={data[0]} bind:filter={filter}/>
<RadioWithInput change={change} data={data[1]} bind:filter={filter} hasDateInputs={true}/>
<RadioNoInput change={change} data={data[2]} bind:filter={filter}/>